import React, { Suspense } from 'react';
import uniqid from 'uniqid';
import { BaseRoute } from '@modules/auth/moleculas';

import { Route } from 'react-router-dom';
import type { RouteProps } from '@config/routes';
import { SuspenseFallback } from '@lib/router/suspense-fallback';

const renderRoutes = (routes: RouteProps[]) => {
    return routes.map(({ path, children, ...props }) => {
        const { isIndex, ...otherProps } = props;

        const key = uniqid('route-key-');
        const element = (
            <Suspense fallback={<SuspenseFallback />}>
                <BaseRoute path={path} {...otherProps} />
            </Suspense>
        );

        if (isIndex) {
            return <Route key={key} path={path} index element={element} />;
        }

        return (
            <Route key={key} path={path} element={element}>
                {children && renderRoutes(children)}
            </Route>
        );
    });
};

export { renderRoutes };
